import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconResourceUrl = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
      data-fill-none
    >
      <g>
        <path
          d="M9.15429 23.0783H3.46388C2.49643 23.0783 1.71216 22.2149 1.71216 21.1497V3.79259C1.71216 2.72747 2.49643 1.86401 3.46388 1.86401H20.9811C21.9485 1.86401 22.7328 2.72746 22.7328 3.79259V11.989"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.69385 7.69873H22.7328"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g>
          <path
            d="M21.5584 20.8495L19.0618 18.0914C19.0331 18.0602 19.0175 18.0174 19.0187 17.9731C19.0243 17.9285 19.0456 17.8881 19.0779 17.8606L20.6921 16.6295C20.8666 16.4982 20.955 16.2666 20.9181 16.0377C20.8874 15.8112 20.7407 15.6244 20.5414 15.5582L13.6812 13.321C13.5381 13.276 13.384 13.319 13.2777 13.4335C13.1859 13.5508 13.1554 13.7118 13.1969 13.8596L15.2469 21.3763C15.3063 21.5938 15.4736 21.7548 15.6774 21.7906C15.8856 21.8312 16.0961 21.734 16.2154 21.542L17.3346 19.7664C17.3633 19.7318 17.4053 19.7143 17.4476 19.719C17.4869 19.7174 17.5254 19.7322 17.5552 19.7605L20.068 22.5245C20.2778 22.754 20.6168 22.754 20.8266 22.5245L21.5853 21.69C21.7902 21.4503 21.7782 21.0727 21.5584 20.8495Z"
            fill="currentColor"
          />
        </g>
      </g>
    </SvgIcon>
  ))
);
